import React from 'react'

export default props => {
	return (
		<div>
			<h1>Borrowed Equipments here.</h1>
		</div>
	)
}
